import { Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from './form';

interface INewsletter {
	mobile: boolean;
}

export const Newsletter: FC<INewsletter> = ({ mobile }) => {
	const { t } = useTranslation();

	return (
		<Flex
			position={mobile ? 'relative' : 'absolute'}
			mt={mobile ? '35px' : '138px'}
			flexDirection="column"
			gridGap="20px"
			mb="50px"
			alignItems={mobile ? 'center' : 'flex-start'}
		>
			<Text
				fontSize="12px"
				fontWeight="600"
				letterSpacing="0.08em"
				color="#6D6D6D"
				textTransform="uppercase"
			>
				{t('footer.newsletter.header')}
			</Text>
			{/*
			<Text fontSize="12px">{t('footer.newsletter.desc')}</Text>
			<Flex gridGap={mobile ? '15px' : '9px'} flexDirection={mobile ? 'column' : 'row'}>
				<Input
					placeholder={t('footer.newsletter.placeholder')}
					bgColor="#FFF"
					w={mobile ? '90vw' : '280px'}
					color="#000"
				/>
				<Button borderRadius="4px" fontSize="12px">
					{t('footer.newsletter.signUp')}
				</Button>
			</Flex> */}
			<Form />
		</Flex>
	);
};
